var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.991,
    height: 14.991,
    viewBox: "0 0 14.991 14.991",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "export",
    transform: "translate(0.75 1.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "export-2",
    "data-name": "export",
    d: "M14.885,5h3.3V8.3m0-3.3-6.59,6.59M10.931,5H6.648A1.648,1.648,0,0,0,5,6.648v9.885a1.648,1.648,0,0,0,1.648,1.648h9.885a1.648,1.648,0,0,0,1.648-1.648V12.249",
    transform: "translate(-5 -5)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.c8cc50989a07bf85fc45308c4b17a026.svg";
export { ForwardRef as ReactComponent };